<template>
  <el-aside v-if="menus.length" class="aside-container">
    <el-menu
      style="height: 100%;"
      :default-active="defaultActiveMenu"
      :default-openeds="defaultOpeneds"
      mode="vertical"
      router
      :collapse="isCollapse"
      text-color="#909399"
    >
      <menu-item
        v-for="child in menus"
        :key="child.path"
        :menuItem="child"
        :isTree="true"
      ></menu-item>
    </el-menu>
    <el-button class="collapse-btn" type="primary" :icon="!isCollapse ? 'el-icon-s-fold' : 'el-icon-s-unfold'" size="small" circle @click="isCollapse = !isCollapse"></el-button>
  </el-aside>
</template>

<script>
import $mitt from '@/utils/mitt';
import MenuItem from './components/menuItem.vue';

export default {
  name: 'Aside',
  components: {
    MenuItem,
  },
  data() {
    return {
      isCollapse: false,
      defaultActiveMenu: '',
      menus: [],
    }
  },
  watch: {
    $route: {
      handler: function(value) {
        this.defaultActiveMenu = value.path;
      },
      immediate: true,
    },
  },
  computed: {
    defaultOpeneds() {
      return this.menus.map((item) => item.path);
    },
  },
  created() {
    $mitt.on('routeChange', (data) => {
      this.menus = data;
    });
  },
}
</script>

<style lang="scss" scoped>
.aside-container {
  width: max-content !important;
  position: relative;
  .collapse-btn {
    position: absolute;
    left: 50%;
    bottom: 20px;
    transform: translateX(-50%);
  }
}
</style>


// WEBPACK FOOTER //
// src/layout/aside.vue